import MainCart, { CartProps } from '@/components/MainInventory/MainCart';
import { cartStore } from '@/stores/cart.store';

const CartModal = ({
    items,
    type,
    load,
    setPage,
    selectedGame,
}: Omit<CartProps, 'setSelectedById' | 'selectedItemIds'>) => {
    const { setSelectedById, selectedItemIds } = cartStore((state) => state);

    return (
        <>
            <MainCart
                setSelectedById={setSelectedById}
                selectedItemIds={selectedItemIds}
                items={items.filter((item) => selectedItemIds.has(item.id))}
                type={type}
                load={load}
                setPage={setPage}
                selectedGame={selectedGame}
                mobile
            />
        </>
    );
};

export default CartModal;
